import React from 'react';

import CustomAvatar from '@app/components/UI/CustomAvatar/CustomAvatar';
import imagePlaceholder from '@app/images/image-placeholder.png';

const PetMemorialThumb = ({
	index,
	item,
	activeThumb,
	showThumb,
	thumbHeight = 200,
	thumbWidth = 280,
	imageAltCapture,
}) => {
	const [imgSrc, setImgSrc] = React.useState(item);

	React.useEffect(() => {
		setImgSrc(item);
	}, []);

	return (
		<div
			className={
				activeThumb === index ? 'pet-mem-modal__content-gallery-nav-item_wrapper active' : 'pet-mem-modal__content-gallery-nav-item_wrapper'
			}
		>
			<CustomAvatar
				key={index}
				src={imgSrc}
				alt={imageAltCapture}
				className="pet-mem-modal__content-gallery-nav-item"
				maxHeight={thumbHeight}
				maxWidth={thumbWidth}
				errorAvatar={imagePlaceholder}
				onClick={() => showThumb(index)}
			/>
		</div>
	);
};

export default PetMemorialThumb;
